import React from 'react'
import Homes from './Homes'
import MenusContent from './MenusContent'



function AllMenu() {

  return (
    
    <>

    <Homes />

    <MenusContent />

    </>

  )

}



export default AllMenu
